export function attachCollectionHeaderEvents() {
  if ($('.js-show-more').length) {
    $('.js-show-more').on('click', toggleHeightHandler)
  }
}

export function attachCollectionHeaderToggleLink() {
  if ($('.collection-header .description-wrap').height() > 54 && $(window).width() < 1024) {
    $('.js-show-more').show();
  } else {
    $('.js-show-more').hide();
  }
}

function toggleHeightHandler() {
  $('.collection-header').toggleClass('auto-height');
  $(this).html() == 'See more &gt;' ? $(this).html('See less') : $(this).html('See more >')
}